module.exports = __webpack_public_path__ + "assets/img/second_user.abd216f7.png";